// extracted by mini-css-extract-plugin
export default {"colorRunTime":"RunTime_colorRunTime__+iYgJ","timeSize":"RunTime_timeSize__wq9pW"};